// src/api/perfilApi.js
//
// Perfil de las 3 entidades y gestión de cuenta.

import { api, API_BASE_URL, tokenStorage } from './apiClient';

export const perfilVeci = {
  obtener:  ()      => api.get('/api/holaveci/perfil/veci'),
  actualizar: (dto) => api.put('/api/holaveci/perfil/veci', dto),
  eliminarFoto: ()  => api.delete('/api/holaveci/perfil/veci/foto'),

  /**
   * Sube foto de perfil. Backend acepta multipart/form-data con clave 'archivo'.
   */
  subirFoto: async (file) => {
    const fd = new FormData();
    fd.append('archivo', file);
    const r = await fetch(`${API_BASE_URL}/api/holaveci/perfil/veci/foto`, {
      method: 'POST',
      body: fd,
      headers: { Authorization: `Bearer ${tokenStorage.get()}` },
    });
    if (!r.ok) {
      const txt = await r.text().catch(() => '');
      throw new Error(txt || 'No se pudo subir la foto.');
    }
    return r.json();
  },
};

export const perfilNegocio = {
  obtener:    ()     => api.get('/api/holaveci/perfil/negocio'),
  actualizar: (dto)  => api.put('/api/holaveci/perfil/negocio', dto),

  domiciliariosListar: () => api.get('/api/holaveci/perfil/negocio/domiciliarios'),
  domiciliarioAgregar: (dto) => api.post('/api/holaveci/perfil/negocio/domiciliarios', dto),
  domiciliarioActualizar: (id, dto) => api.put(`/api/holaveci/perfil/negocio/domiciliarios/${id}`, dto),
  domiciliarioEliminar: (id) => api.delete(`/api/holaveci/perfil/negocio/domiciliarios/${id}`),
};

export const cuenta = {
  darDeBajaVeci: (payload) =>
    api.post('/api/holaveci/cuenta/veci/dar-de-baja', payload),
};

export const passwords = {
  cambiar: (payload) =>
    api.patch('/api/holaveci/perfil/password', payload),
};
